'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    messageBarBodyClassNames: function() {
        return messageBarBodyClassNames;
    },
    useMessageBarBodyStyles_unstable: function() {
        return useMessageBarBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const messageBarBodyClassNames = {
    root: 'fui-MessageBarBody'
};
const useRootBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rtatq2b", "re2rary", [
    ".rtatq2b{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);grid-area:body;padding-right:var(--spacingHorizontalM);}",
    ".re2rary{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);grid-area:body;padding-left:var(--spacingHorizontalM);}"
]);
const useMessageBarBodyStyles_unstable = (state)=>{
    'use no memo';
    const rootBaseStyles = useRootBaseStyles();
    state.root.className = (0, _react.mergeClasses)(messageBarBodyClassNames.root, rootBaseStyles, state.root.className);
    return state;
};
